var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Careers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4165,
    transform: "translate(-1235 -4103)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi:youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66634 9.99992L10.1263 7.99992L6.66634 5.99992V9.99992ZM14.373 4.77992C14.4597 5.09325 14.5197 5.51325 14.5597 6.04659C14.6063 6.57992 14.6263 7.03992 14.6263 7.43992L14.6663 7.99992C14.6663 9.45992 14.5597 10.5333 14.373 11.2199C14.2063 11.8199 13.8197 12.2066 13.2197 12.3733C12.9063 12.4599 12.333 12.5199 11.453 12.5599C10.5863 12.6066 9.79301 12.6266 9.05967 12.6266L7.99967 12.6666C5.20634 12.6666 3.46634 12.5599 2.77967 12.3733C2.17967 12.2066 1.79301 11.8199 1.62634 11.2199C1.53967 10.9066 1.47967 10.4866 1.43967 9.95325C1.39301 9.41992 1.37301 8.95992 1.37301 8.55992L1.33301 7.99992C1.33301 6.53992 1.43967 5.46659 1.62634 4.77992C1.79301 4.17992 2.17967 3.79325 2.77967 3.62659C3.09301 3.53992 3.66634 3.47992 4.54634 3.43992C5.41301 3.39325 6.20634 3.37325 6.93967 3.37325L7.99967 3.33325C10.793 3.33325 12.533 3.43992 13.2197 3.62659C13.8197 3.79325 14.2063 4.17992 14.373 4.77992Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cca9d772e1a58a0fa783898ab50cc01f.svg";
export { ForwardRef as ReactComponent };